if (!customElements.get('hero-slider')) {
  customElements.define(
    'hero-slider',
    class Hero extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.init();
      }

      async init() {
        await customElements.whenDefined('swiper-container');

        const [main, secondary, mainMob, secondaryMob] = await Promise.all([
          this.waitSwiper('[data-swiper-hero-main]'),
          this.waitSwiper('[data-swiper-hero-secondary]'),
          this.waitSwiper('[data-swiper-hero-main-mobile]'),
          this.waitSwiper('[data-swiper-hero-secondary-mobile]')
        ]);

        this.link(main, secondary);
        this.link(mainMob, secondaryMob);

        const frac     = await this.waitEl('[data-pagination-fraction]');
        const fracMob  = await this.waitEl('[data-pagination-fraction-mobile]');
        const dotsMob  = await this.waitEl('[data-pagination-dots-mobile]');

        await this.ensurePagination(secondary,    frac,    { type: 'fraction' });
        await this.ensurePagination(secondaryMob, fracMob, { type: 'fraction' });
        await this.ensurePagination(mainMob,      dotsMob, { type: 'bullets', clickable: true });

        setTimeout(() => {
          this.ensurePagination(secondary,    frac,    { type: 'fraction' });
          this.ensurePagination(secondaryMob, fracMob, { type: 'fraction' });
          this.ensurePagination(mainMob,      dotsMob, { type: 'bullets', clickable: true });
        }, 200);

        const hasMultiple =
          (main && main.slides && main.slides.length > 1) ||
          (mainMob && mainMob.slides && mainMob.slides.length > 1);

        if (hasMultiple) {
          this.show('[data-carousel-arrows]');
          this.show('[data-pagination-fraction]');
          this.show('[data-pagination-fraction-mobile]');
          this.show('[data-pagination-dots-mobile]');
        } else {
          this.hide('[data-carousel-arrows]');
          this.hide('[data-pagination-fraction]');
          this.hide('[data-pagination-fraction-mobile]');
          this.hide('[data-pagination-dots-mobile]');
        }
      }

      waitEl(selector, root = this, timeout = 5000) {
        return new Promise(resolve => {
          const first = root.querySelector(selector);
          if (first) return resolve(first);
          const obs = new MutationObserver(() => {
            const el = root.querySelector(selector);
            if (el) { obs.disconnect(); resolve(el); }
          });
          obs.observe(root, { childList: true, subtree: true });
          setTimeout(() => { obs.disconnect(); resolve(null); }, timeout);
        });
      }

      waitSwiper(selector, timeout = 6000) {
        return new Promise(resolve => {
          const host = this.querySelector(selector);
          if (!host) return resolve(null);
          if (host.swiper) return resolve(host.swiper);
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            host.removeEventListener('ready', finish);
            clearInterval(poll);
            clearTimeout(timer);
            resolve(host.swiper || null);
          };
          host.addEventListener('ready', finish, { once: true });
          const poll = setInterval(() => { if (host.swiper) finish(); }, 50);
          const timer = setTimeout(finish, timeout);
        });
      }

      link(a, b) {
        if (a && b) {
          a.controller.control = b;
          b.controller.control = a;
        }
      }

      async ensurePagination(swiper, el, opts = {}) {
        if (!swiper || !el) return;
        this.showElement(el);
        swiper.params.pagination = Object.assign(swiper.params.pagination || {}, { el, ...opts });
        if (swiper.pagination && typeof swiper.pagination.init === 'function') {
          try { swiper.pagination.destroy && swiper.pagination.destroy(); } catch (_) {}
          swiper.pagination.init();
          swiper.pagination.render && swiper.pagination.render();
          swiper.pagination.update && swiper.pagination.update();
        }
      }

      show(selector) {
        const el = this.querySelector(selector);
        if (el) this.showElement(el);
      }

      hide(selector) {
        const el = this.querySelector(selector);
        if (el) el.classList.add('hidden');
      }

      showElement(el) {
        el.classList.remove('hidden');
        el.removeAttribute('hidden');
        el.style.display = '';
      }
    }
  );
}
